export enum CafsVariableType {
  Select = "Select",
  Boolean = "Boolean",
  Input = "Input",
  Info = "Info",
  Text = "Text",
  Calculated = "Calculated",
  Remarks = "Remarks",
}
